exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#login-box{\n    width: 350px;\n    margin: auto;\n    text-align: center;\n}\n\n#message-area-field{\n    width: 100%;\n}\n\ntextarea{\n    min-height: 100px;\n}\n\n@media(max-width: 767px){\n    .mat-card{\n        padding: 0px;\n    }\n\n    #login-box{\n        width: 100%;\n    }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/mmam/angular/src/app/contact/contact.component.css
// module id = ../../../../../src/app/contact/contact.component.css
// module chunks = main